import Link from 'next/link'
import { Icon, IconType } from './Icon'

export interface CardProps {
  title: string
  description: string
  href: string
  hasIcon?: boolean
  isDocs?: boolean
  iconType?: IconType
  iconName?: string
}

export function Card({
  title,
  description,
  href,
  hasIcon,
  iconType,
  iconName,
  isDocs = false,
}: CardProps) {
  return (
    <Link
      href={href}
      className="card not-prose bg-background-dark group relative my-2 block w-full cursor-pointer overflow-hidden rounded-2xl border border-white/10 font-normal ring-2 ring-transparent hover:!border-sky-500"
    >
      <div className="relative px-6 py-5">
        {!isDocs && (<div className=" absolute right-5 top-5 text-gray-500 group-hover:text-sky-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className=" h-4 w-4"
          >
            <path d="M7 7h10v10"></path>
            <path d="M7 17 17 7"></path>
          </svg>
        </div>)}
        {hasIcon && (
          <div className="h-6 w-6 fill-gray-100 text-gray-100">
            <Icon
              iconType={iconType!}
              iconName={iconName!}
              className="h-6 w-6 text-sky-500"
            />
          </div>
        )}
        <div className="">
          <h2 className={`${isDocs ? 'mt-0' : 'mt-4'} text-base font-semibold text-white`}>{title}</h2>
          <div className="mt-1 text-sm font-normal leading-6 text-gray-400">
            <p className="line-clamp-2">{description}</p>
          </div>
        </div>
      </div>
    </Link>
  )
}
